"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const LocalAccount_1 = __importDefault(require("../LocalAccount"));
// This is a hook that will automatically fire whenever the selected
// account has changed. In all other regards, it works exactly as
// a regular useEffect hook.
const useAccountChange = (fn, dependencies = []) => {
    const [changed, setChanged] = (0, react_1.useState)(0);
    (0, react_1.useEffect)(() => {
        LocalAccount_1.default.registerOnChange(() => {
            setChanged((c) => c + 1);
        });
    }, []);
    return (0, react_1.useEffect)(fn, [changed, ...dependencies]);
};
exports.default = useAccountChange;
